<template>
  <div id="legal-container" style="max-width:900px; margin:0 auto;">
    <div style="margin:0px 15px; padding:30px 0px;">
      <AMLPolicyZhCn v-if="currentLangCode === 'zh_CN'"></AMLPolicyZhCn>
      <AMLPolicyZhTw v-else-if="currentLangCode === 'zh_TW'"></AMLPolicyZhTw>
      <AMLPolicyEnUs v-else></AMLPolicyEnUs>
    </div>
  </div>
</template>
<script>
import AMLPolicyEnUs from './AMLPolicyEnUs';
import AMLPolicyZhCn from './AMLPolicyZhCn';
import AMLPolicyZhTw from './AMLPolicyZhTw';
import { mutationTypes } from '@/store/mutation-types';
import { getterTypes } from '@/store/getter-types';
import { mapGetters, mapMutations } from 'vuex';
export default {
  components: {
    AMLPolicyEnUs,
    AMLPolicyZhCn,
    AMLPolicyZhTw,
  },
  data() {
    return {
      currentLangCode: 'en_US', // default language
    };
  },
  computed: {
    ...mapGetters([ getterTypes.Getter_Lang ]),
  },
  mounted() {
    const currentLang = this.Getter_Lang;

    const queryString = this.$route.query;

    if (queryString && queryString.lang) {
      if (queryString.lang === 'zh_CN' || queryString.lang === 'zh_TW') {
        this.currentLangCode = queryString.lang;
      }
    } else if (currentLang) {
      if (currentLang.code === 'zh_CN' || currentLang.code === 'zh_TW') {
        this.currentLangCode = currentLang.code;
      }
    }
    const isMobile = this.$route.query.isMobile;
    if (isMobile && isMobile === '1') {
      this.SET_FOR_MOBILE(true);
    } else {
      this.SET_FOR_MOBILE(false);
    }
    this.scrollToTop();
  },
  methods: {
    ...mapMutations([mutationTypes.SET_FOR_MOBILE]),
    scrollToTop() {
      document.getElementById('legal-container').scrollIntoView();
    },
  },
};
</script>
